"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = length;
/**
 * Calculate the absolute difference between two numbers
 * @ignore
 * @param {number} numA
 * @param {number} numB
 * @return {number}
 */
function length(numA, numB) {
  return Math.abs(numA - numB);
}
module.exports = exports["default"];
//# sourceMappingURL=length.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-input-range/lib/js/utils/length.js
 ** module id = 1036
 ** module chunks = 0
 **/